import theme from './baseui.config';
export { styled, useStyletron, withStyle } from './baseui.config';
export default theme;
